import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import SiteTakeoverBackgroundImage from './SiteTakeoverBackgroundImage'
import useCurrentSiteTakeover from 'hooks/useCurrentSiteTakeover'
import { getThemeClassName } from 'lib/theme/themeUtils'
import LayoutContainer from '../LayoutContainer'

const Background = styled(SiteTakeoverBackgroundImage)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
`

const Content = styled(Group)`
  transform: translateZ(0);
`

const Banner = styled(Group)`
  padding: ${rem(12)};
  position: relative;
  min-height: ${rem(60)};
`

interface Props {
  vertical?: App.SiteTakeoverVertical
}
function SiteTakeoverOfferPageBanner({ vertical }: Props) {
  const siteTakeover = useCurrentSiteTakeover({ vertical })

  if (!siteTakeover?.offerPage) {
    return null
  }

  return <Banner direction="horizontal" verticalAlign="center">
    <Background background="default" vertical={vertical} />
    <LayoutContainer>
      <Content
        direction="horizontal"
        gap={12}
        verticalAlign="center"
        horizontalAlign="start"
        tabletHorizontalAlign="center"
        className={getThemeClassName({ mobile: siteTakeover.palette })}
      >
        <BodyText variant="medium">
          {siteTakeover.offerPage.bannerContent}
        </BodyText>
      </Content>
    </LayoutContainer>
  </Banner>
}

export default SiteTakeoverOfferPageBanner
